var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-actualites content"},[_c('h1',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.$t('actualites.title')))]),_vm._v(" "),_c('div',{staticClass:"content-wrap"},[_c('Timeline',{attrs:{"feedName":"vigneron-online"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }